const es = {
  "sale.sale.table_assigned.filter": "Filtrar por mesa",
  "sale.sale.kind.filter": "Filtrar por tipo",
  "sale.sale.agent.filter": "Filtrar por agente",
};

export default es;
